// extracted by mini-css-extract-plugin
export default {"loginModal":"LoginModal_loginModal__SBz9v"};